export const CELL_SIZE = 22;
export const CELL_GAP = 2;

export const MONTH_HEADER_HEIGHT = 24;
export const WEEK_HEADER_HEIGHT = 28;

export const ROW_HEIGHT = 30;

export const LABEL_WIDTH = 60;
